import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import checkSmallImg from "@/assets/icon/check_small.svg";
import { Pressable } from "./Pressable";

export const CheckTag = forwardRef(
  (
    {
      className,
      onClick,
      placeholder,
      isActived,
      disabled,
      hideActiveIcon = false,
      children,
      style,
      id,
      prefix,
    }: {
      className?: string;
      placeholder?: string;
      onClick?: () => void;
      isActived?: boolean;
      hideActiveIcon?: boolean;
      disabled?: boolean;
      children?: React.ReactNode;
      id?: string;
      style?: React.CSSProperties;
      prefix?: React.ReactNode;
    },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <Pressable
        ref={ref}
        style={style}
        id={id}
        className={twMerge(
          "flex items-center overflow-hidden justify-center relative rounded-lg border p-3 text-center",
          disabled
            ? "bg-color-fill-2 border-color-fill-2"
            : "bg-color-fill active:bg-color-fill-2 border-color-fill cursor-pointer hover:bg-color-fill-2",
          isActived ? "border-color-primary" : "",
          children === undefined ? "text-color-text-4" : "",
          className,
        )}
        disabled={disabled}
        onPress={() => {
          if (!disabled) {
            onClick?.();
          }
        }}
      >
        {prefix ? <span className="mr-4">{prefix}</span> : null}
        {children ?? placeholder}
        {isActived && !hideActiveIcon ? (
          <span className="bg-color-primary absolute -bottom-px -right-px flex size-4 items-center justify-center rounded-b-sm rounded-e-sm rounded-s-lg">
            <img src={checkSmallImg} />
          </span>
        ) : null}
      </Pressable>
    );
  },
);
